import API from "./api";

// Fetch all guns
export const getGuns = async () => {
    try {
        const response = await API.get("/guns/all");
        return response.data;
    } catch (error) {
        console.error("Error fetching guns:", error);
    }
};

// Fetch all sales
export const getSales = async () => {
    try {
        const response = await API.get("/invoices");
        return response.data;
    } catch (error) {
        console.error("Error fetching sales:", error);
    }
};

// Fetch all repairs
export const getRepairs = async () => {
    try {
        const response = await API.get("/repairs");
        return response.data;
    } catch (error) {
        console.error("Error fetching repairs:", error);
    }
};

// Fetch all invoices
export const getInvoices = async () => {
    try {
        const response = await API.get("/invoices");
        return response.data;
    } catch (error) {
        console.error("Error fetching invoices:", error);
    }
};


// ✅ Get Users (Customers)
export const getUsers = async () => {
    try {
        const response = await API.get("/customers"); // Update endpoint if needed
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        return [];
    }
};

// ✅ Get Products (Inventory)
export const getProducts = async () => {
    try {
        const response = await API.get("/inventory"); // Replace with the actual endpoint for inventory
        return response.data;
    } catch (error) {
        console.error("Error fetching products:", error);
        return [];
    }
};